import React from "react";
import { useParams } from "react-router";

// import config from "../../../config/config";

import "./AnalyticalMethods.scss";

const SupplementsMethods = () => {
  const { year } = useParams();

  /*
  const download = (refNum) => {
    const url = `${config.baseUri}/analyticalMethods?year=${year}&fileName=${refNum}&volumeNumber=3`;
    window.location = url;
  };
  */

  if (year === "2026" && process.env.REACT_APP_BUILD === "production")
  {
    return ("This chapter is currently not available")
  }

  return (
    <div>
      <h1>{year < 2025 ? `Analytical Methods` : `Supplemental Methods`}</h1>
      {/*
      <ul>
        <li>
          <button onClick={() => download("Supplement Methods")}>
            Supplement Methods
          </button>
        </li>
      </ul>
      */}
      <p>There are no additional methods files for the Supplement chapter.</p>
    </div>
  );
};

export default SupplementsMethods;